'use client'

import type { ComponentProps } from 'react'

import { ScrollArea, ScrollBar } from '@repo/ui/components'
import { Button } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'

export type AISuggestionsProps = ComponentProps<typeof ScrollArea>

export const AISuggestions = ({ children, className, ...props }: AISuggestionsProps) => (
  <ScrollArea className="w-full overflow-x-auto whitespace-nowrap" {...props} data-sentry-element="ScrollArea" data-sentry-component="AISuggestions" data-sentry-source-file="suggestion.tsx">
    <div className={cn('flex w-max flex-nowrap items-center gap-2', className)}>{children}</div>
    <ScrollBar className="hidden" orientation="horizontal" data-sentry-element="ScrollBar" data-sentry-source-file="suggestion.tsx" />
  </ScrollArea>
)

export type AISuggestionProps = Omit<ComponentProps<typeof Button>, 'onClick'> & {
  onClick?: (suggestion: string) => void
  suggestion: string
}

export const AISuggestion = ({
  children,
  className,
  onClick,
  size = 'sm',
  suggestion,
  variant = 'outline',
  ...props
}: AISuggestionProps) => {
  const handleClick = () => {
    onClick?.(suggestion)
  }

  return (
    <Button
      className={cn('cursor-pointer rounded-full px-4', className)}
      onClick={handleClick}
      size={size}
      type="button"
      variant={variant}
      {...props}
    data-sentry-element="Button" data-sentry-component="AISuggestion" data-sentry-source-file="suggestion.tsx">
      {children || suggestion}
    </Button>
  )
}
